module.exports = __webpack_public_path__ + "static/media/ico-add.fec45ade.svg";